import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./NoData.css";
import { NoDataImg } from "../../Assests/Assests";

const NoData = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/newproduct");
  };

  return (
    <div className="nodata-container">
      <img src={NoDataImg} alt="No Data" className="nodata-image" />
      <h3 class="empty-cart-title"> EMPTY ...</h3>
      <h4 class="empty-cart-subtitle">
        Add something to make me happy {":)"}
      </h4>{" "}
      <a href="#" class="empty-cart-btn">
        {" "}
        <Link to="/">Continue Shopping</Link>
      </a>

      
    </div>
  );
};

export default NoData;
